import { useTranslation } from 'react-i18next'

// Rendered by the top-level Sentry.ErrorBoundary. Without it a render crash leaves the
// operator on a blank screen with nothing to do.
export function CrashFallback({ eventId }) {
  const { t } = useTranslation()

  return (
    // role/aria-live because the boundary swaps the whole tree and focus falls to body;
    // autoFocus because a packing terminal's only input is a keyboard-wedge scanner.
    <div
      role="alert"
      aria-live="assertive"
      className="h-screen flex flex-col items-center justify-center bg-gray-100 px-6 text-center"
    >
      <h1 className="text-xl font-semibold text-gray-900">{t('crash.title')}</h1>
      <p className="mt-2 text-sm text-gray-600">{t('crash.description')}</p>
      <div className="mt-6 flex gap-3">
        <button
          type="button"
          autoFocus
          onClick={() => window.location.reload()}
          className="px-4 py-2 rounded-md bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-medium shadow-sm"
        >
          {t('crash.reload')}
        </button>
        {/* Reloading a route that crashes deterministically just crashes again, which on a
            shared terminal mid-shift leaves the operator with nowhere to go. */}
        <button
          type="button"
          onClick={() => window.location.assign('/')}
          className="px-4 py-2 rounded-md border border-gray-300 bg-white hover:bg-gray-50 text-gray-700 text-sm font-medium shadow-sm"
        >
          {t('crash.go_home')}
        </button>
      </div>
      {/* The operator has something to quote when they call this in. */}
      {eventId && <p className="mt-4 text-xs text-gray-400 font-mono">{eventId}</p>}
    </div>
  )
}
